<div class="skeleton-loader">
  <div class="skeleton-paragraph">
    <div class="skeleton-line"
      *ngFor="let item of [].constructor(lines)"></div>
  </div>
</div>